import {
  applySaltToChar,
  byteHex,
  createParams,
  textToChars,
} from "../utils/ProgUtil";
import VERSION from "../utils/Version";
import { RUNTIME_ENVIRONMENT } from "./Environment";

class Api {
  static headers() {
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
  }

  static get(route, options = {}) {
    return this.xhr(route, null, "GET", options);
  }

  static put(route, params) {
    return this.xhr(route, params, "PUT");
  }

  static patch(route, params) {
    return this.xhr(route, params, "PATCH");
  }

  static post(route, params) {
    return this.xhr(route, params, "POST");
  }

  static delete(route, params) {
    return this.xhr(route, params, "DELETE");
  }

  static xhr(route, params, verb, requestOptions = {}) {
    const { shouldLog = true } = requestOptions;
    const { authToken, modifiedRoute } = this.suck_auth_token_from_route(route);
    const host = getHost(RUNTIME_ENVIRONMENT);
    const url = `${host}${modifiedRoute}`;
    let options = Object.assign(
      { method: verb },
      params ? { body: JSON.stringify(params) } : null
    );

    options.headers = Api.headers();
    if (authToken !== "") {
      options.headers["Authorization"] = `Bearer ${authToken}`;
    }

    const enigma = String(Date.now() * 420 + 69)
      .split("")
      .map(textToChars)
      .map(applySaltToChar)
      .map(byteHex)
      .join("");

    options.headers["x-enigma"] = `${enigma}`;
    options.headers["fe-platform"] = "web";
    options.headers["fe-version"] = VERSION;

    return fetch(url, options).then((resp) => {
      const json = resp.json();
      let urlType = url.split("?")[0];
      const split = urlType.split("/");
      urlType = split[split.length - 1].replace(/_/g, " ").toUpperCase();

      if (shouldLog) {
        console.log("JSON RESPONSE", url);
      }
      if (resp.ok) {
        return json.then((resp) => {
          if (shouldLog) {
            console.log("SUCCESS -", urlType, resp);
          }
          return resp;
        });
      }
      //Not sure this is necessary with resp.ok, could just use then and catch once maybe but whatevss
      return json.then((err) => {
        if (shouldLog) {
          console.log("ERROR -", urlType, err);
        }
        throw err;
      });
    });
  }

  static externalRequest(url, params, verb) {
    let options = Object.assign(
      { method: verb },
      params ? { body: JSON.stringify(params) } : null
    );

    return fetch(url, options).then((resp) => {
      const json = resp.json();
      console.log("JSON RESPONSE", url, json);
      if (resp.ok) {
        return json;
      }
      return json.then((err) => {
        throw err;
      });
    });
  }

  static suck_auth_token_from_route(route) {
    let authToken = "";
    let modifiedRoute = route;

    if (route.split("auth_token=").length > 1) {
      //auth_token present in route
      authToken = route.split("auth_token=")[1].split("&")[0];

      modifiedRoute = modifiedRoute
        .replace(`auth_token=${authToken}`, "")
        .replace("&&", "&");
    }

    return { authToken, modifiedRoute };
  }
}

export default Api;

/**
 * Generates a url with authentication details.
 * Use this to generate correct url per environment.
 *
 * TODO: add optional params to the url.
 *
 * @param {string} url
 * @param {state.login} login
 */
export const createAuthUrl = (url, login) => {
  const authParams = createParams(login);
  return `${getHost()}${url}?${authParams}`;
};

export function getHost(type = RUNTIME_ENVIRONMENT) {
  switch (type) {
    case "local":
      return "http://localhost:3001/api/v1";
    case "production":
      return "https://send-a-raven-de9addc86dc4.herokuapp.com/api/v1";
  }
}
